<div class="container-fluid bg-white vh-100 p-0">
  <ClientLogo v-if="this.$route.name != 'behalf_application'" />
  <BreadCrumb :label="service_name" />

  <div v-if="is_form_data_ready" class="d-flex flex-column justify-content-center align-items-center min-vh-50">
    <div v-for="(field, index) in responses" :key="index" class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-2">
      <label :for="field.question" class="fw-bold text-xs text-start d-block mb-2">
        {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
      </label>
      <div class="form-group mt-2">
        <div v-if="field.has_text_area">
          <textarea
          :class="['form-control', 'text-xxs', 'rounded-small', 'p-2', 'shadow-sm', 'textarea-auto-height']"
          v-model="field.value"
          :placeholder="field.question"
          :required="field.is_required"
          :rows="field.initial_rows || 4"
          @input="auto_resize_textarea" 
          >
          </textarea>
          <div>
            <small :id="`error-${field.id}`" class=" text-danger fw-bold text-xs d-none">
              Please fill in this field
            </small>
          </div>
        </div>

        <!-- Correctly handles other Text/Number (using v-else-if) -->
        <div v-else-if="(field.has_text || field.has_number || field.has_date)">
          <input
            :type="field.question === 'Birth Date' ? 'text' : field.question_type"
            class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
            v-model="field.value"
            :placeholder="field.question === 'Birth Date' ? 'YYYY/MM/DD' : field.question"
            :required="field.is_required"
            @input="handle_name_input($event, field)" />
          <div>
            <small :id="`error-${field.id}`" class=" text-danger fw-bold text-xs d-none">
              Please fill in this field
            </small>
          </div>
        </div>

        <div v-if="field.has_multi_selection">
          <div v-for="option in field.options" :key="option.option" class="form-check">
            <input type="checkbox"
              class="form-check-input mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
              v-model="field.value" :value="option.option" :id="`checkbox_${field.id}_${option.option}`"
              @change="handle_multiple_selection($event, field.id, option.id)" />
            <label :for="`checkbox_${field.id}_${option.option}`" class="form-check-label text-xs ms-1">
              {{ option.option }}
            </label>
          </div>
          <div>
            <small :id="`error-${field.id}`" class=" text-danger fw-bold text-xs d-none">
              Please fill in this field
            </small>
          </div>
        </div>

        <div v-if="field.has_checkbox">
          <div v-for="option in field.options" :key="option.option" class="form-check">
            <input type="radio"
              class="form-check-input mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
              v-model="field.value" :value="option.option" :id="`checkbox_${index}_${option.option}`"
              @change="get_follow_up_question(field.id, option.id)" />
            <label :for="`checkbox_${index}_${option.option}`" class="form-check-label text-xs ms-1">
              {{ option.option }}
            </label>
          </div>
          <div>
            <small :id="`error-${field.id}`" class=" text-danger fw-bold text-xs d-none">
              Please fill in this field
            </small>
          </div>
        </div>

        <div v-if="field.has_selection">
          <SearchSelect
            v-if="field.options.length > 5"
            v-model="field.value"
            :options="field.options.map(option => ({ value: option.option, text: option.option }))"
            :placeholder="field.question"
            @change="handle_selection_change(field.id, $event.target.value)"
          />
          <select
            v-else
            class="form-select form-select-sm mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
            v-model="field.value"
            @change="handle_selection_change(field.id, $event.target.value)"  
          >
            <option value="" disabled hidden>{{ field.question }}</option>
            <option v-for="option in field.options" :key="option.id" :value="option.option">
              {{ option.option }}
            </option>
          </select>
          <div>
            <small :id="`error-${field.id}`" class=" text-danger fw-bold text-xs d-none">
              Please fill in this field
            </small>
          </div>
        </div>

        <div v-show="field.has_file">
          <input 
            type="file"
            :required="field.is_required"
            class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
            accept=".pdf"
            @change="on_file_change($event, field.id, false)"
            ref="file_input"
            :name="`file_${field.id}`"/>
          <div v-if="field.value && typeof field.value === 'string' && !field.value.startsWith('blob:')" class="mt-2">
            <div class="card p-1">
              <div class="d-flex justify-content-between align-items-center">
                <div class="text-success text-sm d-flex align-items-center">
                  <i class="bi bi-check-circle-fill me-2"></i>
                  File uploaded
                </div>
              </div>
            </div>
          </div>
          <div>
            <small :id="`error-${field.id}`" class=" text-danger fw-bold text-xs d-none">
              Please upload a file
            </small>
          </div>
        </div>
      </div>

      <div v-for="(fields, group_index) in duplicate_fields" :key="group_index"
        class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <hr class="w-75 mx-auto mb-4" />

        <div v-for="(field, field_index) in fields" :key="`dup_${group_index}_${field_index}`" class="form-group mt-3">
          <label :for="field.question" class="fw-bold text-xs text-start d-block">
            {{ field.question }} <span v-if="field.is_required" class="text-danger">*</span>
          </label>
          <input v-if="(field.has_text || field.has_number || field.has_date)" 
            :type="field.question === 'Birth Date' ? 'text' : field.question_type"
            class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
            v-model="field.value" 
            :placeholder="field.question === 'Birth Date' ? 'YYYY/MM/DD' : field.question" 
            :required="field.is_required"
            @input="handle_name_input($event, field)" />
          <div>
            <small :id="`error-duplicate-${group_index}-${field.id}`" class=" text-danger fw-bold text-xs d-none">
              Please fill in this field
            </small>
          </div>

          <div v-if="field.has_multi_selection">
            <div v-for="option in field.options" :key="option.option" class="form-check">
              <input type="checkbox" class="form-check-input rounded-small shadow-sm" v-model="field.value"
                :value="option.option" :id="`checkbox_${field.id}_${option.option}`"
                @change="handle_multiple_selection($event, field.id, option.id)"/>
              <label :for="`checkbox_${field.id}_${option.option}`" class="fw-bold text-xs text-start d-block">
                {{ option.option }}
              </label>
            </div>
            <div>
              <small :id="`error-duplicate-${group_index}-${field.id}`" class=" text-danger fw-bold text-xs d-none">
                Please fill in this field
              </small>
            </div>
          </div>

          <div v-if="field.has_checkbox">
            <div v-for="option in field.options" :key="option.option" class="form-check">
              <input type="radio"
                class="form-check-input mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                v-model="field.value" :value="option.option" :id="`checkbox_${field_index}_${option.option}`" />
              <label :for="`checkbox_${field_index}_${option.option}`" class="form-check-label text-xs">
                {{ option.option }}
              </label>
            </div>
            <div>
              <small :id="`error-duplicate-${group_index}-${field.id}`" class=" text-danger fw-bold text-xs d-none">
                Please fill in this field
              </small>
            </div>
          </div>

          <div v-if="field.has_selection">
            <SearchSelect
              v-if="field.options.length > 5"
              v-model="field.value"
              :options="field.options.map(option => ({ value: option.option, text: option.option }))"
              :placeholder="field.question"
            />
            <select
              v-else
              class="form-select form-select-sm mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
              v-model="field.value" :id="`${field_index}`">
              <option value="" disabled hidden>{{ field.question }}</option>
              <option v-for="option in field.options" :key="option.option" :value="option.option">
                {{ option.option }}
              </option>
            </select>
            <div>
              <small :id="`error-duplicate-${group_index}-${field.id}`" class=" text-danger fw-bold text-xs d-none">
                Please fill in this field
              </small>
            </div>
          </div>

          <div v-if="field.has_file">
            <input type="file"
              class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
              @change="on_file_change($event, field.id, false, group_index)"
              ref="file_input">
              <div>
              <small :id="`error-duplicate-${group_index}-${field.id}`" class=" text-danger fw-bold text-xs d-none">
                Please upload a file
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Follow-up Questions Section -->
      <div v-if="follow_up_questions.length > 0" class="mt-4">
        <div v-for="(follow_up_field, index) in follow_up_responses" :key="follow_up_field.id"
          v-show="follow_up_field.parent_id === field.id" class="mb-4">
          <label class="fw-bold text-xs text-start d-block mb-2">
            {{ follow_up_field.question }}
            <span v-if="follow_up_field.is_required" class="text-danger">*</span>
          </label>

          <div class="form-group mt-2">

            <div v-if="follow_up_field.has_text_area">
              <textarea
              :class="['form-control', 'text-xxs', 'rounded-small', 'p-2', 'shadow-sm', 'textarea-auto-height']"
              v-model="follow_up_field.value"
              :placeholder="follow_up_field.question"
              :required="follow_up_field.is_required"
              :rows="follow_up_field.initial_rows || 4"
              @input="auto_resize_textarea" 
              @change="update_follow_up_response(follow_up_field.id, follow_up_field.value)"
              >
              </textarea>
              <div>
                <small :id="`error-followup-${follow_up_field.id}`" class=" text-danger fw-bold text-xs d-none">
                  Please fill in this field
                </small>
              </div>
            </div>

            <div v-else-if="(follow_up_field.has_text || follow_up_field.has_number || follow_up_field.has_date)">
              <input :type="follow_up_field.question_type"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                v-model="follow_up_field.value" :placeholder="follow_up_field.question"
                :required="follow_up_field.is_required"
                @input="update_follow_up_response(follow_up_field.id, follow_up_field.value)" />
              <div>
                <small :id="`error-followup-${follow_up_field.id}`" class=" text-danger fw-bold text-xs d-none">
                  Please fill in this field
                </small>
              </div>
            </div>

            <!-- Multi-selection checkboxes -->
            <div v-if="follow_up_field.has_multi_selection">
              <div v-for="option in follow_up_field.options" :key="`${follow_up_field.id}_${option.option}`"
                class="form-check">
                <input 
                  type="checkbox"
                  v-model="follow_up_field.value"
                  class="form-check-input mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                  :checked="follow_up_responses.find(r => r.id === follow_up_field.id)?.value?.includes(option.option)"
                  :value="option.option"
                  :id="`follow_up_checkbox_${follow_up_field.id}_${option.option}`"
                  @change="handle_followup_multiple_selection($event, follow_up_field.id, option.option)"/>
                <label :for="`follow_up_checkbox_${follow_up_field.id}_${option.option}`"
                  class="form-check-label text-xs ms-1">
                  {{ option.option }}
                </label>
              </div>
              <div>
                <small :id="`error-followup-${follow_up_field.id}`" class=" text-danger fw-bold text-xs d-none">
                  Please fill in this field
                </small>
              </div>
            </div>

            <!-- Single-selection radio buttons -->
            <div v-if="follow_up_field.has_checkbox">
              <div v-for="option in follow_up_field.options" :key="`${follow_up_field.id}_${option.option}`"
                class="form-check">
                <input type="radio"
                  class="form-check-input mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                  v-model="follow_up_field.value" :value="option.option"
                  :id="`follow_up_radio_${follow_up_field.id}_${option.option}`"
                  @change="update_follow_up_response(follow_up_field.id, follow_up_field.value)" />
                <label :for="`follow_up_radio_${follow_up_field.id}_${option.option}`"
                  class="form-check-label text-xs ms-1">
                  {{ option.option }}
                </label>
              </div>
              <div>
                <small :id="`error-followup-${follow_up_field.id}`" class=" text-danger fw-bold text-xs d-none">
                  Please fill in this field
                </small>
              </div>
            </div>

            <!-- Dropdown selection -->
            <div v-if="follow_up_field.has_selection">
              <SearchSelect
                v-if="follow_up_field.options.length > 5"
                v-model="follow_up_field.value"
                @change="update_follow_up_response(follow_up_field.id, follow_up_field.value)"
                :options="follow_up_field.options.map(option => ({ value: option.option, text: option.option }))"
                :placeholder="follow_up_field.question"
              />
              <select
                v-else
                class="form-select form-select-sm mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                v-model="follow_up_field.value"
                @change="update_follow_up_response(follow_up_field.id, follow_up_field.value)"
                >
                <option value="" disabled hidden>{{ follow_up_field.question }}</option>
                <option v-for="option in follow_up_field.options" :key="`${follow_up_field.id}_${option.option}`"
                  :value="option.option">
                  {{ option.option }}
                </option>
              </select>
              <div>
                <small :id="`error-followup-${follow_up_field.id}`" class=" text-danger fw-bold text-xs d-none">
                  Please fill in this field
                </small>
              </div>
            </div>

            <!-- File upload -->
            <div v-show="follow_up_field.has_file">
              <input
                type="file"
                :required="follow_up_field.is_required"
                class="form-control mx-auto col-12 col-md-9 col-lg-8 text-xxs rounded-small p-2 shadow-sm"
                @change="($event) => on_file_change($event, follow_up_field.id, true)"
                :name="`followup_file_${follow_up_field.id}`"
                accept=".pdf"
                :ref="`follow_up_file_input_${follow_up_field.id}`" />
              <div v-if="follow_up_field.value && typeof follow_up_field.value === 'string' && !follow_up_field.value.startsWith('blob:')" class="mt-2">
                <div class="card p-1">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="text-success text-sm d-flex align-items-center">
                      <i class="bi bi-check-circle-fill me-2"></i>
                      File uploaded
                    </div>
                  </div>
                </div>
              </div>  
              <div>
                <small :id="`error-followup-${follow_up_field.id}`" class=" text-danger fw-bold text-xs d-none">
                  Please fill in this field
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rest of your existing template (duplicate fields, buttons, etc.) -->
    <div v-for="(fields, group_index) in duplicate_fields" :key="group_index"
      class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
      <!-- Your existing duplicate fields code -->
    </div>

    <div v-if="service_type === 'multi flex form'" class="d-flex justify-content-end mb-3 ms-5r">
      <button class="btn btn-sm bg-green text-white rounded-circle shadow-sm fw-bold me-1"
        v-if="duplicate_fields.length > 0" @click="remove_fields(group_index)" title="Remove">
        <i class="fa fa-trash"></i>
      </button>

      <button class="btn btn-sm bg-green text-white rounded-circle shadow-sm fw-bold" @click.prevent="add_more_fields"
        title="Add More">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <div class="text-center mb-3 mt-5">
      <button
        class="btn btn-sm bg-green secondary-text-dark rounded-small fw-bold text-xs shadow-sm"
        @click="continue_to_next"
        > Continue
      </button>
    </div>
  </div>
</div>
